var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988c5.53 0 10.012 4.483 10.012 10.012S17.529 22.012 12 22.012c-2.2 0-4.232-.713-5.885-1.915l-.044-.032A10 10 0 0 1 1.988 12C1.988 6.47 6.471 1.989 12 1.988m0 13.435-.022-.001a5.05 5.05 0 0 0-4.89 3.893A8.77 8.77 0 0 0 12 20.811a8.77 8.77 0 0 0 4.912-1.496 5.046 5.046 0 0 0-4.89-3.893zm0-12.235a8.813 8.813 0 0 0-5.933 15.327 6.25 6.25 0 0 1 3.532-3.813 4.365 4.365 0 1 1 4.802 0 6.25 6.25 0 0 1 3.53 3.813A8.812 8.812 0 0 0 12 3.188m0 4.705a3.166 3.166 0 1 0 .002 6.332A3.166 3.166 0 0 0 12 7.893"
  })));
};
export default SvgUserCircle;